export default __webpack_public_path__ + "static/media/bakhtiar.c04f97cf.png";